import React from "react"
import { css } from "styled-components"
import VariantContainer from "../atoms/variant-container"
import mergeVariants, { TVariantProp } from "../util/merge-variants"
import VideoProgressBar, { IVideoProgressBar } from "./video-progress-bar"

interface IIconVideoProgressBar extends IVideoProgressBar {
  icon: React.ReactNode
  containerVariants?: TVariantProp
}

const IconVideoProgressBar = ({
  details,
  videoProgress,
  seekMethod,
  icon,
  containerVariants,
  titleVariants,
}: IIconVideoProgressBar) => {
  mergeVariants

  return (
    <VariantContainer
      variants={mergeVariants(
        [
          css`
            display: grid;
            grid-template-columns: auto 1fr;
            grid-gap: 18px;
          `,
        ],
        containerVariants
      )}
    >
      {icon}
      <VideoProgressBar
        details={details}
        videoProgress={videoProgress}
        seekMethod={seekMethod}
        titleVariants={titleVariants}
      />
    </VariantContainer>
  )
}

export default IconVideoProgressBar
